import { LESSONS_PAGE_SIZE } from '../../constants';

export type LessonsPaginationDataArgs = {
    // index to load, starts with 1
    page?: number | null;
    // page size to load, defaults to 10
    pageSize?: number;
    // flag to load only lessons, without course data
    onlyLessons?: boolean;
}

/**
 * Method that generates and returns additional params for pagination
 */
export function getLessonsPaginationData(args: LessonsPaginationDataArgs) {
    const {
        page,
        pageSize = LESSONS_PAGE_SIZE,
        onlyLessons
    } = args;
    if (page === null || page === undefined) {
        return null;
    }

    // onlyLessons вовращает курс только с уроками, без данных собственно курса
    // делаем это либо по флагу снаружи, либо при загрузке 2 и далее страницы
    const onlyLessonsValue = onlyLessons !== undefined ? onlyLessons : page !== 1;

    /* eslint-disable camelcase */
    return {
        page,
        page_size: pageSize,
        only_clessons: onlyLessonsValue
    };
    /* eslint-enable camelcase */
}
